import { render, staticRenderFns } from "./CustomizingDefaultHeader.vue?vue&type=template&id=2b98bb3e&"
import script from "./CustomizingDefaultHeader.vue?vue&type=script&lang=js&"
export * from "./CustomizingDefaultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports